const forms = Array.from(document.querySelectorAll('form.async'))

function sendData(url, formData, form) {

    fetch(url, {
        method: 'post',
        headers: {
            // This is required for Silverstripes isAjax() method to pass
            'x-requested-with': 'XMLHttpRequest' 
        },
        body: formData 
    })
    .then(response => {
        response.text().then(value => {
            form.querySelector('.message').outerHTML = value
            form.reset()
        })
    })
    .catch(console.warn)
}

function handleSubmit(e) {
    e.preventDefault()

    const form = e.target
    const data = new FormData(e.target)
    const url = form.getAttribute('action')

    sendData(url, data, form)
}

function decorateForm(form) {
    form.addEventListener('submit', handleSubmit)
}

export function main() {

    if (forms.length) {
        forms.forEach(decorateForm)
    }
}
